/**
 * Shared `grid-template-columns` builder for the Kronos entry list.
 *
 * Keep the row + header in one place so they stay aligned — a change
 * to a column width only needs to happen here.
 *
 * Column order:
 *   When · Duration · [Project] · Designation · [Teammate] · Description · Actions
 *
 * `Project` is hidden on the per-project Kronos tab (entries all
 * belong to the same project). `Teammate` is hidden for non-
 * rd_manager viewers.
 */
export function entryGridTemplate(opts: {
  showProject: boolean;
  showUser: boolean;
}): string {
  const cols: string[] = [];
  cols.push('140px'); // When
  cols.push('80px'); // Duration
  if (opts.showProject) cols.push('1fr'); // Project
  cols.push('1.2fr'); // Designation
  if (opts.showUser) cols.push('1fr'); // Teammate
  cols.push('1.4fr'); // Description
  cols.push('auto'); // Actions
  return cols.join(' ');
}
